import recommendPng from '/recommend.png'
import {css} from "@emotion/react";
import {Button, Card, Image, Input, Menu, Space, Spin, Tag, Typography} from "antd";
import Icon, {CloseCircleOutlined, CloseOutlined, DesktopOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import runAsync from "@/script/runAsync.mjs";
import FileUtils from "@/script/FileUtils";
import useHTTP from "@/hooks/useHTTP.mjs";
import * as antIcons from "antd-mobile-icons";

const {CheckableTag} = Tag
const {Text, Paragraph} = Typography
const fallbackImage = "data:image/png;base64,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"


/**
 * 选择界面视图模板弹窗
 * @param uvType
 * @param pageType
 * @param onOk
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function SelectUvTemplateDialog({uvType, pageType, umUiLayoutType, onOk, ...props}) {
    const http = useHTTP();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});

    const [tagsData, setTagsData] = useState([])
    const [selectedTags, setSelectedTags] = useState([]);

    const [keyword, setKeyword] = useState('')

    const regExpLabelSplit = /,|，/

    const cssItem = {
        width: 300,
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        border: '1px solid #f0f0f0',
        borderRadius: 6,
        '&:hover': {
            cursor: 'pointer',
        },
    }
    const cssItemScale = {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        gap: 8,
        padding: 12,
        // '&:active': {
        //     transform: 'scale(0.95)',
        // }
    }
    const cssItemActive = {
        border: '2px solid #13c2c2'
    }
    const cssItemScaleActive = {
        padding: 10
    }
    const cssCover = {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #f0f0f0',
        borderRadius: 6,
    }
    const cssTags = {
        display: 'flex',
        // gap: 12,
    }
    const cssFooter = css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',

    })

    const doQuery = async () => {
        setLoading(true)
        try {
            const data = await runAsync(
                async () => {
                    return await http.get(`/listOnBasUvTemplate`, {"umUv.uvType": uvType, "umUv.pageType": pageType, umUiLayoutType});
                }, {
                    error: {content: (err) => `查询失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                });

            setData(data);

            //计算标签
            let tagsData = []
            if (data) {
                data.forEach(({label}) => {
                    if (label) {
                        tagsData = [...tagsData, ...label.split(regExpLabelSplit)]
                    }
                })

                tagsData = Array.from(new Set(tagsData))
            }

            setTagsData(tagsData)
        } finally {
            setLoading(false)
        }
    }

    const handleSearch = async (value) => {
        setKeyword(value)
    }

    const handleTagsChange = (tag, checked) => {
        const nextSelectedTags = checked
            ? [...selectedTags, tag]
            : selectedTags.filter((t) => t !== tag);

        setSelectedTags(nextSelectedTags);
    };

    const handleSelected = async (item) => {
        if (selected.pkid == item.pkid) {
            setSelected({})
        } else {
            setSelected({
                pkid: item.pkid,
                name: item.name,
                content: item.umUv.uvMap,
            })
        }
    }

    const handleClearSelected = async () => {
        setSelected({})
    }

    const handleOk = () => {
        if (selected.pkid) {
            onOk(selected)
        } else {
            onOk()
        }
    }

    const handleCancel = async () => {
        onOk()
    }

    useEffect(() => {
        doQuery()
    }, [])

    return (
        <Modal
            title={"选择模板"}
            width={1280}
            style={{top: 20}}
            bodyStyle={{overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 0}}
            footer={
                <div css={cssFooter}>
                    <Space>
                        <span>当前选择:</span>
                        {
                            selected.name && (
                                <>
                                    <span>{selected.name}</span>
                                    <Button title='取消选择' icon={<CloseCircleOutlined/>} danger ghost size='small' type='link' onClick={handleClearSelected}></Button>
                                </>
                            )
                        }
                    </Space>
                    <Space>
                        <Button size="small" onClick={handleCancel}>取消</Button>
                        <Button size="small" type="primary" onClick={handleOk}>确定</Button>
                    </Space>
                </div>
            }
            {...props}
        >
            <div style={{display: 'flex', flexDirection: 'column', flexShrink: 0, padding: 12, gap: 12,}}>
                <Input.Search loading={loading} placeholder='输入关键词进行模糊搜索' allowClear enterButton="搜索" onSearch={handleSearch}/>

                {
                    tagsData.length > 0 && (
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <span style={{marginRight: 12}}> 模板标签:</span>
                            {tagsData.map((tag) => (
                                <CheckableTag
                                    key={tag}
                                    checked={selectedTags.indexOf(tag) > -1}
                                    onChange={(checked) => handleTagsChange(tag, checked)}
                                >
                                    {tag}
                                </CheckableTag>
                            ))}
                        </div>
                    )
                }

            </div>

            <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden', padding: 12, gap: 12, background: '#eee'}}>
                {
                    loading && (
                        <div style={{display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center',}}>
                            <Spin spinning={loading}/>
                        </div>
                    )
                }
                {
                    !loading && (
                        <>

                            <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'auto',}}>
                                <div style={{display: 'flex', flexWrap: 'wrap', gap: 12,}}>
                                    {
                                        data.filter(item => {
                                            if (keyword) {
                                                const {pkid, name, cover, description, content, uvType, pageType} = item
                                                if (name) {
                                                    if (name.toLowerCase().includes(keyword.toLowerCase())) {
                                                        return true
                                                    } else {
                                                        return false
                                                    }
                                                } else {
                                                    return false
                                                }
                                            } else {
                                                return true
                                            }
                                        }).filter(item => {
                                            if (selectedTags.length > 0) {
                                                const {label} = item;
                                                if (label) {
                                                    const itemLabels = label.split(regExpLabelSplit);
                                                    return itemLabels.filter(itemLabel => selectedTags.includes(itemLabel)).length > 0
                                                } else {
                                                    return false
                                                }
                                            } else {
                                                return true
                                            }
                                        }).map(item => {
                                            const {pkid, name, cover, description, label, umUv: {uvTypeName, pageTypeName}} = item
                                            return (
                                                <div css={[cssItem, selected.pkid === pkid ? cssItemActive : {}]} onClick={() => handleSelected(item)}>
                                                    <div css={[cssItemScale, selected.pkid === pkid ? cssItemScaleActive : {}]}>
                                                        <div css={cssCover} onClick={e => e.stopPropagation()}>
                                                            <Image height={180}
                                                                   style={{objectFit: 'contain'}}
                                                                   src={FileUtils.getFileUrl(cover)}
                                                                   fallback={fallbackImage}
                                                            />
                                                        </div>
                                                        <Text strong ellipsis={{tooltip: name,}}>{name}</Text>
                                                        <Text type='secondary' style={{fontSize: 12}} ellipsis={{tooltip: description ?? "暂无描述",}}>{description ?? "暂无描述"}</Text>
                                                        <div css={cssTags}>
                                                            {
                                                                !label && <div style={{height: 22}}></div>
                                                            }
                                                            {
                                                                label && label.split(regExpLabelSplit).map(item => {
                                                                    return <Tag>{item}</Tag>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </Modal>
    )
}

/**
 * 选择界面视图模板按钮
 * @param uvType
 * @param pageType
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
function UvTemplateButton({
                              uvType, pageType, onChange = () => {
    }
                          }) {
    const openModal = useOpenModal()

    const handleClick = async () => {
        const result = await openModal(<SelectUvTemplateDialog uvType={uvType} pageType={pageType}/>)
        if (result) {
            onChange(result)
        }
    }

    return (
        <Space style={{marginLeft: 4}}>
            <a onClick={handleClick}>
                <DesktopOutlined style={{marginRight: 4}}/>
                选择模板
            </a>
            <img src={recommendPng} style={{width: 36,}}/>
        </Space>
    )
}

export {UvTemplateButton}
